import { render, staticRenderFns } from "./alloc-resource.vue?vue&type=template&id=6800fe6d&scoped=true&"
import script from "./alloc-resource.vue?vue&type=script&lang=ts&"
export * from "./alloc-resource.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6800fe6d",
  null
  
)

export default component.exports